import React from 'react';
import { getShippingMethodGroups } from '../shippingMethodOptions';
import PickupSchedulingNotice from '../PickupSchedulingNotice';

export default function MethodsStep({ state, setField, shipToCountries }) {
    const selectedMethods = state.methods || [];
    const groups = getShippingMethodGroups({
        originCountry: state.originCountry,
        shipToCountries,
        mode: state.mode,
    });
    const hasLocalPickup = selectedMethods.includes('LOCAL_PICKUP');

    const handleMethodChange = (methodValue, checked) => {
        if (checked) {
            setField('methods', [...selectedMethods, methodValue]);
            return;
        }
        setField('methods', selectedMethods.filter((method) => method !== methodValue));
    };

    return (
        <div className="shipping-step">
            <h3>Shipping Methods</h3>
            {groups.map((group) => (
                <fieldset key={group.carrier} className="shipping-fieldset">
                    <legend>{group.carrier}</legend>
                    {group.note && <p className="help">{group.note}</p>}
                    {group.methods.map((method) => (
                        <React.Fragment key={method.value}>
                            <label className="checkbox">
                                <input
                                    type="checkbox"
                                    value={method.value}
                                    checked={selectedMethods.includes(method.value)}
                                    onChange={(e) => handleMethodChange(method.value, e.target.checked)}
                                />
                                <span>{method.label}</span>
                            </label>
                            {method.value === 'LOCAL_PICKUP' && hasLocalPickup && (
                                <div className="shipping-method-detail group">
                                    <label>Pickup Address</label>
                                    <input
                                        type="text"
                                        placeholder="eg: 123 Main St, City, State, ZIP"
                                        value={state.pickupAddress || ''}
                                        onChange={(e) => setField('pickupAddress', e.target.value)}
                                    />
                                    <p className="help">
                                        Only city, state, and ZIP are shown to buyers before purchase.
                                        Full address is revealed after payment.
                                    </p>
                                    <PickupSchedulingNotice />
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </fieldset>
            ))}
        </div>
    );
}
